export default {
    "GPSMAP": {
        "DEVICE": "Eszköz",
        "ALL_DEVICES": "Összes eszköz",
        "USER": "Felhasználó",
        "ALL_USERS": "Összes felhasználó",
        "FROM": "Ettől",
        "TO": "Eddig",
        "HEATMAP": "Hőtérkép",
        "HEAT_RADIUS": "Hősugár",
        "PATHS": "Útvonal eszközönként",
        "LOAD": "Adatok betöltése",
        "CLEAR": "Törlés",
    }
}



// WEBPACK FOOTER //
// ./src/i18n/messages/hu/gpsmap.js